<template>
  <div
    :class="classes(
      n(),
      n(`--${size}`),
    )
    "
    role="text"
    :aria-label="text"
  >
    <slot />
    <div
      v-if="visible"
      :class="classes(
        n('content'),
        [!!$slots.default, n(`--float`)],
        [dot, n('--dot'), n(`--${shape}`)],
      )"
      :style="getOffsetStyle"
    >
      {{ text }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'virtual-vue';
import { createNamespace } from '../utils/components';
import { props } from './props';
import { emits } from './emits';

const { name, n, classes } = createNamespace('badge');

export default defineComponent({
  name,
  props,
  emits,
  setup(props) {
    const getOffsetStyle = computed(() => ({
      right: typeof props.offset[0] === 'number' ? `${props.offset[0]}px` : props.offset[0],
      top: typeof props.offset[1] === 'number' ? `${props.offset[1]}px` : props.offset[1],
    }));

    // 如果是红点，展示badge，在非红点情况下，text为空字符串，那就不展示badge
    const visible = computed(() => props.dot || props.text !== '');

    return {
      classes,
      n,
      getOffsetStyle,
      visible,
    };
  },
});
</script>
